import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { FormSetHasActiveForm, FormSetIsDirty, FormSetIsSubmitted, FormSetIsValid, SetFormState } from '../action/active-form.action';
import { ActiveFormStateModel } from '../interface/active-form.interface';

@State<ActiveFormStateModel>({
    name: 'activeForm',
    defaults: {
        hasActiveForm: false,
        isValid: false,
        isDirty: false,
        isSubmitted: false,
    },
})
@Injectable()
export class ActiveFormState {
    @Selector()
    static getFormState(state: ActiveFormStateModel) {
        return state;
    }

    @Action(FormSetHasActiveForm)
    formSetHasActiveForm(ctx: StateContext<ActiveFormStateModel>, action: FormSetHasActiveForm) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            hasActiveForm: action.hasActiveForm,
        });
    }

    @Action(FormSetIsValid)
    formSetIsValid(ctx: StateContext<ActiveFormStateModel>, action: FormSetIsValid) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            isValid: action.isValid,
        });
    }

    @Action(FormSetIsDirty)
    formSetIsDirty(ctx: StateContext<ActiveFormStateModel>, action: FormSetIsDirty) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            isDirty: action.isDirty,
        });
    }

    @Action(FormSetIsSubmitted)
    formSetIsSubmitted(ctx: StateContext<ActiveFormStateModel>, action: FormSetIsSubmitted) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            isSubmitted: action.isSubmitted,
        });
    }

    @Action(SetFormState)
    setFormState(ctx: StateContext<ActiveFormStateModel>, action: SetFormState) {
        const state = ctx.getState();
        ctx.setState({
            hasActiveForm: action.state.hasActiveForm,
            isValid: action.state.isValid,
            isDirty: action.state.isDirty,
            isSubmitted: action.state.isSubmitted,
        });
    }
}
